import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { OctHeaderWrapper } from '@oceantech/oceantech-ui';
import { useAuth } from '../../app/modules/auth';
import { HeaderWrapper } from './components/header'
import { RightToolbar } from '../partials/layout/RightToolbar'
import { ScrollTop } from './components/scroll-top'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { Sidebar } from './components/sidebar'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import { ToolbarWrapper } from './components/toolbar'
import { localStorageItem } from "../../app/modules/utils/LocalStorage";
import {convertListMenus} from "../../app/modules/utils/AppFunction";
import {CODE_ROUTES} from "../../app/modules/utils/Constant";

const MasterLayout = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const listMenu = localStorageItem.get("id-token-decode")?.menus?.["oceantech-wms-server"]
  // const menus = listMenu?.[0]?.subs ?? [];
  // const menus = [...listMenu?.[0]?.subs].sort((a, b) => a.order - b.order);
  useEffect(() => {
    reInitMenu()
  }, [location.key])
  const menus = [...convertListMenus(listMenu?.[0]?.subs, [CODE_ROUTES.DUYET_TONGHOP])].sort((a: any, b: any) => a.order - b.order);

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {/*<HeaderWrapper />*/}
            <OctHeaderWrapper
              menuOptions={menus}
              hasCache
              onLogout={logout}
            />
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid p-0'>
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                {/* <FooterWrapper /> */}
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        <ActivityDrawer />
        {/* <RightToolbar /> */}
        <DrawerMessenger />
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        <InviteUsers />
        <UpgradePlan />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export { MasterLayout }
